import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import moment from 'moment';

@Injectable({
    providedIn: 'root'
})
/**
 * @deprecated Can only be removed once all end points have been refactored.
 */
export class TimestampInterceptor implements HttpInterceptor {

    private urlsArrPayload: string[] = [
        '/tour-stop-tracking',
        '/shift/edit',
        '/tour-stop-tracking/edit',
        '/shift-break/edit',
        '/actions-status-cancel',
        '/actions-status-update',
        '/checklist',
        '/tour-stop-tracking',
    ];
    private urlsObjPayload: string[] = [
        '/shift/start',
        '/shift/stop',
        '/fuel-refill',
        '/sign-submit-protocols',
        '/upsert-driver-note',
        '/delete-driver-note',
    ];

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        if (req.method === 'POST' || req.method === 'PUT' || req.method === 'DELETE') {

            const newReqBody = this.interceptBody(req.body, req.url);
            const newReq: HttpRequest<any> = req.clone({
                body: newReqBody
            });

            return next.handle(newReq);
        }

        return next.handle(req);
    }

    public interceptBody(payload: any, fullUrl: string): any {
        const timestamp = moment().toISOString(true);
        if (this.urlsArrPayload.some(url => fullUrl.includes(url))) {
            return payload.map(elem => ({ ...elem, timestamp }));

        } else if (this.urlsObjPayload.some(url => fullUrl.includes(url))) {
            return { ...payload, timestamp };

        } else {
            return payload;
        }

    }

}
